import { MainColor } from '../../palette/colors';
import { DefaultClientConfig } from '../../client';

export const getAvailabilityChartTheme = (brandColors: DefaultClientConfig) => {
  return {
    subheader: 'coolGrey60' satisfies MainColor as MainColor,
    header: 'navy95' satisfies MainColor as MainColor,
    axes: {
      top: {
        color: 'coolGrey60' satisfies MainColor as MainColor,
        borderColor: 'coolGrey30' satisfies MainColor as MainColor,
        backgroundColor: brandColors.background.default,
      },
      left: {
        borderColor: 'coolGrey30' satisfies MainColor as MainColor,
        color: 'coolGrey60' satisfies MainColor as MainColor,
      },
    },
    chart: {
      background: 'coolGrey5' satisfies MainColor as MainColor,
      colors: [
        'chartStackedBar0',
        'chartStackedBar1',
        'chartStackedBar2',
        'chartStackedBar3',
        'chartStackedBar4',
        'chartStackedBar5',
        'chartStackedBar6',
        'chartStackedBar7',
        'chartStackedBar8',
        'chartStackedBar9',
        'chartStackedBar10',
        'chartStackedBar11',
        'chartStackedBar12',
      ] satisfies MainColor[] as MainColor[],
      bar: {
        stroke: 'coolGrey30' satisfies MainColor as MainColor,
        active: {
          backgroundColor: 'coolGrey20' satisfies MainColor as MainColor,
        },
      },
      scales: {
        color: 'coolGrey30' satisfies MainColor as MainColor,
      },
      zeroIndicator: {
        color: 'coolGrey40' satisfies MainColor as MainColor,
      },
      timeIndicator: {
        color: brandColors.background.default,
        backgroundColor: 'forest50' satisfies MainColor as MainColor,
      },
    },
  };
};

export type AvailabilityChartTheme = ReturnType<typeof getAvailabilityChartTheme>;
